import { OperationSettingDTO } from '@/models';
import { axiosBase } from './axios-base';

export const fetchOperationSettings = (): Promise<{ data: OperationSettingDTO }> => {
  return axiosBase.get('/api/operation/settings');
};

export const saveOperationSettings = (body: OperationSettingDTO): Promise<{ data: OperationSettingDTO }> => {
  return axiosBase.put('/api/operation/settings', body);
};